/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { createGlobalStyle } from 'styled-components';
import StyledProps from './theme/AppThemeInterface';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
    font-size: ${({ theme }: StyledProps) => theme.defaultFontSize};
    background-color: ${({ theme }: StyledProps) => theme.primaryBackgroundColor};

    @media print {
      margin: 0px;
     -webkit-print-color-adjust: exact;
      background-color: white;
    }

    & .MuiNativeSelect-select {
      option {
        font-family: "Source Sans Pro", Corbel, sans-serif;
        background-color: white !important;
        color: black;
      }
    }
  }
`;

export default GlobalStyle;
